import { useContext, useEffect, useState } from 'react';
import FormDelivery from '../../components/form-delivery/form-delivery.component';
import PageHeader from '../../components/page-header/page-header.component';
import SummaryView from '../../components/summary/summary.view.component';
import { CartContext } from '../../contexts/cart.context';
import { formatViewNumber } from '../../utils/utils';
import './delivery.styles.scss';

const Delivery = () => {
  const { cartItems, cartTotal } = useContext(CartContext);
  const [discount, setDiscount] = useState(0);
  const [promoCode, setPromoCode] = useState('');
  const [freeShipping, setFreeShipping] = useState(false);
  const [priceWithDiscount, setPriceWithDiscount] = useState(cartTotal);

  // Ces règles doivent rester identiques à getOrderId.php, qui recalcule tout côté serveur :
  // ici on ne fait qu'AFFICHER, c'est le serveur qui décide du montant réellement débité.
  const deliveryPrice = cartTotal > 50 ? 0 : 5.99;
  const effectiveDelivery = freeShipping ? 0 : deliveryPrice; // code « livraison offerte »

  useEffect(() => {
    const totalPrice =
      Math.round((cartTotal + effectiveDelivery - discount) * 100) / 100;

    setPriceWithDiscount(totalPrice);
  }, [cartTotal, effectiveDelivery, discount]);

  const subtotal = cartItems.reduce(
    (total, cartItem) => total + cartItem.quantity * cartItem.price,
    0
  );

  const roundSubtotal = Math.round(subtotal * 100) / 100;

  return (
    <div className="delivery-page">
      <PageHeader
        overline="Commande"
        title="Livraison"
        lead="Renseignez votre adresse de livraison ; le paiement se fait à l'étape suivante, sur la plateforme sécurisée de notre banque."
      />

      <div className="delivery-body">
        <FormDelivery cartItems={cartItems} promoCode={promoCode} />
        <SummaryView
          deliveryPrice={formatViewNumber(effectiveDelivery)}
          discount={discount}
          priceWithDiscount={formatViewNumber(priceWithDiscount)}
          setDiscount={setDiscount}
          setPromoCode={setPromoCode}
          setFreeShipping={setFreeShipping}
          subtotal={formatViewNumber(roundSubtotal)}
        />
      </div>
    </div>
  );
};

export default Delivery;
